<template>
  <div class="p-4">
    <div class="flex justify-end" v-if="showCreate">
      <button class="btn btn-primary rounded btn-xs" @click="show = true">
        {{ $t("Buttons.createGame") }}
      </button>
    </div>
    <div v-if="loading" class="h-40 flex flex-col items-center justify-center">
      <div class="loading loading-ring loading-lg"></div>
    </div>
    <div
      v-else-if="
        (!isMyMate && gameList.length === 0) ||
        (isMyMate &&
          gameHomeStore.create[2].length + gameHomeStore.create[1].length === 0)
      "
      class="h-40 flex flex-col items-center justify-center"
    >
      <div class="text-2xl font-bold text-base-content/50">
        {{ $t("Message.noGamesYet") }}
      </div>
      <div class="text-base-content/50">
        {{ $t("Message.noGamesYetDesc") }}
      </div>
    </div>
    <ItemGalGameHome
      v-for="game in [...gameHomeStore.create[2], ...gameHomeStore.create[1]]"
      v-else-if="isMyMate"
      :key="game"
      :game="gameHomeStore.gameMap[game]"
      mode="edit"
    />
    <ItemGalGameHome
      v-for="game in gameList"
      v-else
      :key="game.uuid"
      :game="game"
    />
  </div>

  <ModalCreateScript v-model:show="show" />
</template>
<script setup lang="ts">
import { ApiGetGalGamePage } from "@/apis/gal-game";
import { useGalGameHome } from "@/stores/galGameHome";
import { onMounted, ref } from "vue";
const props = defineProps({
  isMyMate: {
    type: Boolean,
    default: false,
  },
  mateId: {
    type: Number,
    default: 0,
  },
  showCreate: {
    type: Boolean,
    default: true,
  },
});

const gameHomeStore = useGalGameHome();

const gameList = ref<GalGame[]>([]);

const show = ref(false);
const loading = ref(false);

const fetchMateGame = async () => {
  if (props.isMyMate) return gameHomeStore.initCreate();
  loading.value = true;
  const { page } = await ApiGetGalGamePage({ mateId: props.mateId });
  gameList.value = page.data;
  loading.value = false;
};

onMounted(() => {
  fetchMateGame();
});
</script>
